import TranslationForm from './TranslationForm';

export default TranslationForm;